/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page_banner[_ngcontent-%COMP%]{background:url(/assets/images/solucoes.jpg) center center no-repeat #333;position:relative}.hostin_features.amarelo[_ngcontent-%COMP%]{background-color:#fba529}.hostin_features.cinza[_ngcontent-%COMP%]{background-color:#737373}.hostin_features.vermelho[_ngcontent-%COMP%], .plan_header.vermelho[_ngcontent-%COMP%]{background-color:#d43b3b}.plan_footer[_ngcontent-%COMP%]{background-color:#fba529!important;color:#fff;font-weight:700}\n/*# sourceMappingURL=generic.component.css.map*/"];
export { styles as styles };
